// extracted by mini-css-extract-plugin
export default {"notFound":"styles__notFound--d1426fc893678417ce86"};